var _rect, _path, _path2, _g, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-15681 -21355C-15681 -21356.1 -15680.1 -21357 -15679 -21357H25709C25710.1 -21357 25711 -21356.1 25711 -21355V17516C25711 17517.1 25710.1 17518 25709 17518H-15679C-15680.1 17518 -15681 17517.1 -15681 17516V-21355Z",
    fill: "#FAEFDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-14896 -2290C-14896 -2291.1 -14895.1 -2292 -14894 -2292H12041C12042.1 -2292 12043 -2291.1 12043 -2290V17060C12043 17061.1 12042.1 17062 12041 17062H-14894C-14895.1 17062 -14896 17061.1 -14896 17060V-2290Z",
    fill: "#F4DDC6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3201_20605)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1437,
    height: 8854,
    transform: "translate(-1136 -412)",
    fill: "#E37617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1056 -412H301V8442H-1056V-412Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3201_20605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-830 -224C-830 -226.761 -827.761 -229 -825 -229H75C77.7615 -229 80 -226.761 80 -224V8368C80 8370.76 77.7614 8373 75 8373H-825C-827.761 8373 -830 8370.76 -830 8368V-224Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-14894 -2291H12041V-2293H-14894V-2291ZM12042 -2290V17060H12044V-2290H12042ZM12041 17061H-14894V17063H12041V17061ZM-14895 17060V-2290H-14897V17060H-14895ZM-14894 17061C-14894.6 17061 -14895 17060.6 -14895 17060H-14897C-14897 17061.7 -14895.7 17063 -14894 17063V17061ZM12042 17060C12042 17060.6 12041.6 17061 12041 17061V17063C12042.7 17063 12044 17061.7 12044 17060H12042ZM12041 -2291C12041.6 -2291 12042 -2290.55 12042 -2290H12044C12044 -2291.66 12042.7 -2293 12041 -2293V-2291ZM-14894 -2293C-14895.7 -2293 -14897 -2291.66 -14897 -2290H-14895C-14895 -2290.55 -14894.6 -2291 -14894 -2291V-2293Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-15679 -21356H25709V-21358H-15679V-21356ZM25710 -21355V17516H25712V-21355H25710ZM25709 17517H-15679V17519H25709V17517ZM-15680 17516V-21355H-15682V17516H-15680ZM-15679 17517C-15679.6 17517 -15680 17516.6 -15680 17516H-15682C-15682 17517.7 -15680.7 17519 -15679 17519V17517ZM25710 17516C25710 17516.6 25709.6 17517 25709 17517V17519C25710.7 17519 25712 17517.7 25712 17516H25710ZM25709 -21356C25709.6 -21356 25710 -21355.6 25710 -21355H25712C25712 -21356.7 25710.7 -21358 25709 -21358V-21356ZM-15679 -21358C-15680.7 -21358 -15682 -21356.7 -15682 -21355H-15680C-15680 -21355.6 -15679.6 -21356 -15679 -21356V-21358Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3201_20605",
    x: -842,
    y: -233,
    width: 934,
    height: 8626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3201_20605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3201_20605",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3201_20605",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3201_20605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1437,
    height: 8854,
    fill: "white",
    transform: "translate(-1136 -412)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3201_20605",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADOElEQVR4nO2cTW4UMRBGexPukLEnWyS2uQRhnwsgXFMmcDAiJCTgCgHE3xGIBCwBQWAPck+UkCHT7UH2uKr6+ySvInf3qzd2u2fS7joEQRAEERby8bfl1mlL64IRhECI6LT+BBNGyLCQTnlIO496AGs86gGs8agHsMajHsAaj3oAazzqAazxqAewxqMewBqPegBrPOoBrPGoB7DGox7AGo96AGs86gGs8agHsMajHsAaj3oAazzqAazxqAewxqMewBqPegBpPIe3Dm8Ev3hAnl+R51+rF4QWN6xBX8OX5Pko1XYjGXfnR7Pg43sUPVb64PE72qPdDUYGZFDtWcDFt7RPO6NCltMUpiTaRg3mHEeFLO8Zl52C56dpCssaXsjaLPzCkY/PrtY2vujGEjz//LtTOtBoJyQr99xDvzJKzuQv74xn4/pCSN1AiLBAiLBASMXEWZyTj4/Tzblvjp/wjG8O9YGQmjJc/Lpa4ODit/S3df0gpFLOR8a6h77jgX5YZdXI+TR1rZDg+MdAPwjZthBy8ftAPwipkXQDH5iyHq3tByF1klZT6Qb+z3Tl+Uv6imRdPwipv+w9TveM1NLIGJKRAiHCAiHCAiHCAiHCAiHCAiHCAiHCAiHC0kyI9X8l6grVpXyHzONYa12hupTvkHkca60rVJfyHTKPY611hepSvkPl40gJhAgLhAgLhAgLhAgLhAjLZIQs3OJOcPG09TI2uHgaHB9IqUuzEwfPH1vLoEspn6XUpdmJIUSaEMcH5PhD69FB/TXcvy2lLu1PLDwEIbLSUshZiZc+MUKKvfR59bXo9Crv/0iBkOtk8PONX4tOe3HUuGm2fg4JI88Z43WpcF2zyFlba/R7cWxJSFr715ZBF40/iRHi+HXW1hr9yfdot9+LYwtCUpGmJiS4+CZ785mLC9innbQXB3k+Wd3doewI2dJziBt+zqgtZFlDPknTVPbIKJlcIVpC2nnUA1jjUQ9gjUc9gDWeXICp/R7SLNmrrIn9HtIsEKJVyMR+D2kW9QDWeNQDWONRD2CNRz2ANR71ANZ41ANY42m+jPV1W6ctrQtGEAIhotP6E0wYIQiCIEg3rfwBw8m4zuKjXr4AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.670c84fe5b18704fed1f74a7831d0104.svg";
export { ForwardRef as ReactComponent };